import React from 'react';

function NotFound(props) {
	return (
		<div className="container main">
			<div className="heading mt-4">Page Not Found</div>
			<div className="mt-2 mb-4">
				<p>We're sorry, the page you requested could not be found. Please go back to the home page.</p>
				<a class="btn btn-primary" href="/" role="button">Return Home</a>
			</div>
		</div>
	);
}

export default NotFound;